export const stringIsNumber = (stringToCheck: string | number): boolean => {
  let isNumber = false;
  isNumber = !isNaN(+stringToCheck) && stringToCheck.toString().length !== 0;
  return isNumber;
};
